module.exports = __webpack_public_path__ + "img/farzana-christopher-137.fa5a4660.jpg";